export const menuList = [
  {
    status: 'finished',
    text: 'dashboard',
    desc: 'Dashboard',
    src: '/images/cards/pose_f9.webp',
    icon: 'ic:round-dashboard',
    subModule: [{ name: '- Overview page showing your castle details and progress' }],
    color: 'primary'
  },
  {
    status: 'finished',
    text: 'planner',
    desc: 'Planner',
    src: '/images/cards/pose_f9.webp',
    icon: 'arcticons:school-planner',
    subModule: [{ name: '- Building and Technology planner with Azurite Calculator integrated' }]
  },
  {
    status: 'finished',
    text: 'troops',
    desc: 'Troops Setup',
    src: '/images/cards/pose_f9.webp',
    icon: 'game-icons:rally-the-troops',
    subModule: [{ name: '- Save and compare troop templates' }, { name: '- Configure march formations and setups' }]
  },
  {
    status: 'finished',
    text: 'azurite',
    desc: 'Azurite',
    src: '/images/cards/pose_f9.webp',
    icon: 'game-icons:crystal-growth',
    subModule: [{ name: '- Calculate azurite costs and requirements for upgrades' }]
  },
  {
    status: 'finished',
    text: 'building',
    desc: 'Building',
    src: '/images/cards/pose_f9.webp',
    icon: 'emojione-monotone:construction',
    subModule: [
      { name: '- Full building list with upgrade details' },
      { name: '- Recommended upgrade paths for efficient growth' }
    ]
  },
  {
    status: 'new',
    text: 'shields',
    desc: 'Shields',
    src: '/images/cards/pose_f9.webp',
    icon: 'material-symbols:security',
    subModule: [{ name: '- Track shield timers across multiple realms' }]
  },
  {
    status: 'finished',
    text: 'speeds',
    desc: 'Speeds',
    src: '/images/cards/pose_f9.webp',
    icon: 'material-symbols:speed-outline',
    subModule: [{ name: '- Calculate speed-up totals and troop recruitment times' }]
  },
  {
    status: 'finished',
    text: 'beast',
    desc: 'Beast',
    src: '/images/cards/pose_f9.webp',
    icon: 'game-icons:beast-eye',
    subModule: [
      { name: '- Beast Talents Simulator' },
      { name: '- Beast Skills Simulator' },
      { name: '- Experience Chart' }
    ]
  },
  {
    status: 'finished',
    text: 'totem',
    desc: 'Totem',
    src: '/images/cards/pose_f9.webp',
    icon: 'game-icons:totem',
    subModule: [{ name: '- Stats Comparator' }, { name: '- Stones and Scrolls Calculator' }]
  },
  {
    status: 'finished',
    text: 'colossus',
    desc: 'Colossus',
    src: '/images/cards/pose_f9.webp',
    icon: 'game-icons:giant',
    subModule: [{ name: '- Simulate and plan your Colossus skill builds' }]
  },
  {
    status: 'new',
    text: 'garden',
    desc: 'Garden',
    src: '/images/cards/pose_f9.webp',
    icon: 'game-icons:flower-pot',
    subModule: [{ name: '- View decoration stats, sets, and statues' }]
  },
  {
    status: 'finished',
    text: 'mystic',
    desc: 'Mystic College',
    src: '/images/cards/pose_f9.webp',
    icon: 'basil:university-outline',
    subModule: [{ name: '- Plan and simulate Mystic College research paths' }]
  },
  {
    status: 'finished',
    text: 'college',
    icon: 'menu_book',
    desc: 'High College',
    src: '/images/cards/pose_f9.webp',
    icon: 'la:school',
    subModule: [{ name: '- Simulate and optimize High College skill trees' }]
  },
  {
    status: 'finished',
    text: 'minitools',
    desc: 'Minitools',
    src: '/images/cards/pose_f9.webp',
    icon: 'et:tools-2',
    subModule: [{ name: '- Calculate Angel Dust conversion and requirements' }]
  },
  {
    status: 'finished',
    text: 'database',
    desc: 'Database List',
    src: '/images/cards/pose_f9.webp',
    icon: 'carbon:data-volume',
    subModule: [
      { name: '- Obsidian enhancement level data' },
      { name: '- VIP & SVIP level benefits' },
      { name: '- Additional reference tables' }
    ]
  },
  {
    status: 'finished',
    text: 'packs',
    desc: 'Packs',
    src: '/images/cards/pose_f9.webp',
    icon: 'emojione-monotone:money-with-wings',
    subModule: [{ name: '- Browse and compare available packs and their value' }]
  },
  {
    status: 'finished',
    text: 'artifacts',
    desc: 'Artifacts',
    src: '/images/cards/pose_f9.webp',
    icon: 'game-icons:glowing-artifact',
    subModule: [
      { name: '- Artifact Simulator' },
      { name: '- Experience and Shards calculator' },
      { name: '- Artifact List' }
    ]
  },
  {
    status: 'finished',
    text: 'equipment',
    desc: 'Equipment',
    src: '/images/cards/pose_f9.webp',
    icon: 'game-icons:shoulder-armor',
    subModule: [{ name: '- Equipment Simulator' }, { name: '- Enhancement Simulator' }, { name: '- Equipment List' }]
  },
  {
    status: 'new',
    text: 'jewels',
    desc: 'Jewels',
    src: '/images/cards/pose_f9.webp',
    icon: 'game-icons:diamond-hard',
    subModule: [
      { name: '- 6 Legendary/Epic/Rare Jewels' },
      { name: '- 5-Star Upgrade Progression' },
      { name: '- Special Effects & Bonuses' }
    ]
  },
  {
    status: 'finished',
    text: 'guides',
    desc: 'Guides',
    src: '/images/cards/pose_f9.webp',
    icon: 'mdi:book-open-page-variant-outline',
    subModule: [
      { name: '- Elite War and Anubis Tower stat swaps' },
      { name: '- Every enhancement, listed by equipment slot' },
      { name: '- What the upgrade cost tables add up to' }
    ]
  },
  {
    status: 'finished',
    text: 'realms',
    desc: 'Realms',
    src: '/images/cards/pose_f9.webp',
    icon: 'bi:globe',
    subModule: [{ name: '- View realm merge history and upcoming merges' }]
  },
  {
    status: 'finished',
    text: 'contributors',
    desc: 'Contributors',
    src: '/images/cards/pose_f9.webp',
    icon: 'mdi:help-outline',
    subModule: [{ name: '- Meet the team behind WaO Tools' }, { name: '- Support the project' }]
  },
  {
    status: 'finished',
    text: 'releases',
    desc: 'Release Notes',
    src: '/images/cards/pose_f9.webp',
    icon: 'material-symbols:new-releases',
    subModule: [{ name: '- Changelog and latest feature updates' }]
  }
]
